"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _constants = require("../constants");

var _common = require("@insided/shared/utils/common");

var alignmentOptions = _common.common.isModuleActive('imageResizingAndAlignment') ? ['JustifyLeft', 'JustifyCenter', 'JustifyRight', '-'] : [];
var desktopControl = [{
  name: 'styles',
  items: ['Styles', 'Callout', 'Bold', 'Italic', 'Underline', 'Strike', 'TextColor', 'BGColor', 'RemoveFormat', '-', 'BulletedList', 'NumberedList', '-'].concat(alignmentOptions, ['InsidedEmoji', 'Link', 'EasyImageUpload', 'ImageUpload', 'InsidedAttachment', 'Blockquote', 'Iorad', 'Embed', 'CodeSnippet', 'HorizontalRule', 'Spoiler', '-', 'Source', 'Table', 'More'])
}];
var desktopDestination = [{
  name: 'styles',
  items: ['Styles', 'Bold', 'Italic', 'Underline', 'Strike', 'TextColor', 'BGColor', 'RemoveFormat', '-', 'BulletedList', 'NumberedList', '-'].concat(alignmentOptions, ['InsidedEmoji', 'Link', 'EasyImageUpload', 'ImageUpload', 'InsidedAttachment', 'Blockquote', 'Embed', 'CodeSnippet', 'Spoiler', '-', 'Source'])
}, {
  name: 'insert',
  items: ['Table', 'More']
}];
var desktopDestinationWithoutUpload = [{
  name: 'styles',
  items: ['Styles', 'Bold', 'Italic', 'Underline', 'Strike', 'TextColor', 'BGColor', 'RemoveFormat', '-', 'BulletedList', 'NumberedList', '-'].concat(alignmentOptions, ['InsidedEmoji', 'Link', 'Blockquote', 'Embed', 'CodeSnippet', 'Spoiler', '-', 'Source'])
}, {
  name: 'insert',
  items: ['Table', 'More']
}];
var email = [{
  name: 'styles',
  items: ['EmailWidgets', 'Variable', '-', 'Styles', 'Bold', 'Italic', 'Underline', 'Strike', 'TextColor', 'BGColor', 'RemoveFormat', '-', 'BulletedList', 'NumberedList', '-', 'JustifyLeft', 'JustifyCenter', 'JustifyRight', '-', 'InsidedEmoji', 'Link', 'EasyImageUpload', 'ImageUpload', 'Iorad']
}, {
  name: 'insert',
  items: ['HorizontalRule', 'More']
}, {
  name: 'styles',
  items: ['Source']
}];

var byEnvironment = function byEnvironment(environment) {
  var IsUploadNotAllowed = !_common.common.isModuleActive('nonModeratorsCanUploadImagesAndVideos');
  var toolbarItems = null;

  if (environment === _constants.env.CONTROL) {
    toolbarItems = desktopControl;
  } else if (IsUploadNotAllowed) {
    toolbarItems = desktopDestinationWithoutUpload;
  } else {
    toolbarItems = desktopDestination;
  }

  return toolbarItems;
};

var getToolbar = function getToolbar(profile, environment) {
  switch (profile) {
    case 'email':
      return email;

    case 'openingPost':
    default:
      return byEnvironment(environment);
  }
};

var _default = getToolbar;
exports.default = _default;